import { Component, OnInit } from '@angular/core';
import { SortDescriptor } from '@progress/kendo-data-query';
import { ExcelExportEvent, GridComponent, PageChangeEvent, RowArgs, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { GlguideService } from '../../../core/services/glguide.service';
import { UserService } from '../../../core/services/user.service';
import { GLGuide } from '../../../core/shared/model/GLGuide';
import { GLCode } from '../../../core/shared/model/GLCode';
import { FSInvoiceDialogService } from '../../../core/services/fsinvoice.dialog.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { State, process } from '@progress/kendo-data-query';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';
import { lastValueFrom } from 'rxjs';
const createFormGroup = dataItem => new FormGroup({
  'glSequence': new FormControl(dataItem.glSequence),
  'glCode': new FormControl(dataItem.glCode, Validators.required),
  'glDescription': new FormControl(dataItem.glSubscription),
});


@Component({
  selector: 'app-glcodemaintenance',
  templateUrl: './glcodemaintenance.component.html',
  styleUrls: ['./glcodemaintenance.component.scss']
})

export class GLCodeMaintenanceComponent implements OnInit {
  //glcodemaints: Array<GLCodeMaint>;
  skip = 0;
  pageSize: number = 30;
  selectedKeys: string[];
  username: string;
  glguides: Array<GLGuide> = new Array<GLGuide>();
  glguidedescriptions: string[];
  indexglguide: number;
  glguide: number;
  glCodes: Array<GLCode>=[];
  glCode: GLCode;
  selectAllState: SelectAllCheckboxState = 'unchecked';
  selectedGLCodesMap: Map<string, GLCode> = new Map<string, GLCode>();
  public _stateCodesTable: any;
  gridData: any;
  _glCodesState: any;
  glCodesGridData: any;
  glsummarysequenceinput: number;
  glcodeinput: number;
  gldescriptioninput: string;
  response: any;
  public formGroup: FormGroup;
  private _newSummaryTextValue: number = null;
  private _newCodeTextValue: number = null;
  private _newDescriptionTextValue: string = null;
  private _editedRowIndex: number;
  private _editedGLCode: GLCode;
  codeMaintForm: FormGroup;
  result: any;
  scale =0.7;
  isAddValid: boolean = false;
  selectedValue: string;

  sort: SortDescriptor[] = [{
    field: 'siteName',
    dir: 'asc'
  }];

  constructor(public userService: UserService,
    public glguideService: GlguideService,
    public loadingIndicator:LoadingIndicatorHelper,
    public dialogService: FSInvoiceDialogService) {

    this.selectedKeys = [];
    this.exportAllData = this.exportAllData.bind(this);
  }

  async ngOnInit() {
    this.loadingIndicator.show();
    this._newSummaryTextValue = null;
    this._newCodeTextValue = null;
    this._newDescriptionTextValue = null;

    this.initForm();
    this.selectedGLCodesMap.clear();
    this.username = this.userService.getUserName();

    await this.glguideService.getGLGuideList(this.username)
      .subscribe(async glguides => {
        if (glguides !== undefined) {
          this.glguides = glguides;
          this.userService.setGLGuides(this.glguides);

          this.glguides = this.userService.getGLGuides();
          this.glguidedescriptions = this.glguides.map(a => a.glGuide);

          //defaults to first item in list
          this.selectedValue = this.glguidedescriptions[0];
          this.glguideService.glguidedescription = this.selectedValue;

          this.indexglguide = this.glguides.findIndex(x => x.glGuide = this.selectedValue);

          if (this.glguides[this.indexglguide] !== undefined) {
            this.glguideService.setglguide(this.glguides[this.indexglguide].glGuideId);

            await this.glguideService.getGLCodes(this.glguides[this.indexglguide].glGuideId)
              .subscribe(glcodes => {
                this.glCodes = glcodes;
              });
          }
          if (this.glguideService.glReviewList === undefined && this.glguideService._glguide !== undefined) {
            await this.glguideService.getGLGuideItems().then(r => r);
          }

          if (this.glguideService.glAuditList === undefined) {
            await this.glguideService.getGLAuditItems(new Date(), new Date()).then(r => r);
          }
        }
        this.loadingIndicator.hide();
      });
  }

  initForm() {
    this.codeMaintForm = new FormGroup({
      glSequence: new FormControl(this._newSummaryTextValue, [Validators.required]),
      glCode: new FormControl(this._newCodeTextValue, [Validators.required]),
      glDescription: new FormControl(this._newDescriptionTextValue, [Validators.required])
    });
  }

  tableHeaderCheckBoxChanged(checked: boolean) {
    if (checked) {
    }
  }

  allRowsSelected(selectionObj: any) {
    if (selectionObj == 'checked') {
      this.tableHeaderCheckBoxChanged(true);
      this.selectAllState = selectionObj;
    } else if (selectionObj == 'unchecked') {
      this.tableHeaderCheckBoxChanged(false);
      this.selectAllState = selectionObj;
    } else {
      selectionObj.deselectedRows.forEach(row => {
        var index = this.selectedKeys.indexOf(row.dataItem.glcode);
        this.selectedKeys.splice(index, 1);
        this.rowCheckBoxChanged(false, row.dataItem);
      });
      selectionObj.selectedRows.forEach(row => {
        if (!this.selectedKeys.includes(row.dataItem.glcode)) {
          this.selectedKeys.push(row.dataItem.glCode);
          this.rowCheckBoxChanged(true, row.dataItem);
        }
      });
    }

  }

  async addClicked() {
    let summary: string;
    let code: string;
    let description: string;

    if ((this.newSummaryTextValue !== undefined) && (this.newCodeTextValue !== undefined) && (this.newDescriptionTextValue !== undefined && this.newDescriptionTextValue !== '')) {
      summary = this.newSummaryTextValue.toString().trim();
      code = this.newCodeTextValue.toString().trim();
      description = this.newDescriptionTextValue.toString().toUpperCase().trim();
      this.glguide = this.glguideService.getglguide();
      this.response = this.glguideService.addGLCategory(this.glguide.toString(), code, summary, description, this.username)
        .subscribe(response => {
          this.response = response;
        });
    }
  }

  async addHandler(event) {
    let summary: string;
    let code: string;
    let description: string;

    if ((this.newSummaryTextValue !== null) && (this.newCodeTextValue !== null) && (this.newDescriptionTextValue !== null && this.newDescriptionTextValue !== '')) {
      this.loadingIndicator.show();
      summary = this.newSummaryTextValue.toString().trim();
      code = this.newCodeTextValue.toString().trim();
      description = this.newDescriptionTextValue.toString().toUpperCase().trim();
      this.glguide = this.glguideService.getglguide();
      this.response = lastValueFrom(this.glguideService.addGLCategory(this.glguide.toString(), code, summary, description, this.username))
        .then(r => {
          this.ngOnInit().then(r => {
            this.loadingIndicator.hide();
          });
          this.userService.showNotification('Item Successfully Added', 2000);   
        this.validateForm();
        }).catch((error) => {
          console.error(error);
          this.loadingIndicator.hide();
          this.userService.showError('Problem Adding Item', 2000);
        })

    } else {
      return;
    }
  }

  async guideChange($event) {
    this.loadingIndicator.show();
    this.glguideService.glguidedescription = this.selectedValue;
    this.indexglguide = this.glguides.findIndex(x => x.glGuide === this.selectedValue);

    this.glguideService.setglguide(this.glguides[this.indexglguide].glGuideId);

    await lastValueFrom(this.glguideService.getGLCodes(this.glguides[this.indexglguide].glGuideId))
      .then(r => {
        this.glCodes = r;
        this.loadingIndicator.hide();
      });
  }

  editClicked(event) {
    this.closeEditor(event.sender);
    this._editedRowIndex = event.rowIndex;
    this._editedGLCode = Object.assign({}, event.dataItem);
    event.sender.editRow(event.rowIndex);
  }

  public saveHandler(event) {
    this.loadingIndicator.show();
    this.glguide = this.glguideService.getglguide();
    lastValueFrom(this.glguideService.updateGLCategory('update', this.glguide, event.dataItem.glCode, event.dataItem.glSequence,
      event.dataItem.glDescription, this.username))
      .then(r => {
        this.userService.showNotification('Item Successfully Updated', 2000);
      }).catch((error) => {
        console.error(error);
        this.userService.showError('Problem Updating Item', 2000);
      });
    event.sender.closeRow(event.rowIndex);
    this._editedRowIndex = undefined;
    this._editedGLCode = undefined;
    this.loadingIndicator.hide();
  }

  public cancelClicked(event) {
    this.closeEditor(event.sender, event.rowIndex);
    this.ngOnInit().then(r => r);
  }

  async removeClicked(event) {
    await this.dialogService.showYesNoDialog('Remove', 'Are you sure you would like to remove ' + event.dataItem.glDescription + '?')
      .subscribe(async res => {
        this.result = res;

        if (this.result == true) {
          this.loadingIndicator.show();
          this.glguide = this.glguideService.getglguide();
          await lastValueFrom(this.glguideService.deleteCategory('destroy', this.glguide, event.dataItem.glSequence))
            .then(r => {
              this.ngOnInit().then(r => {
                this.loadingIndicator.hide();
              });
              this.userService.showNotification('Item Successfully Removed', 2000);
            }).catch((error) => {
              console.error(error);
              this.loadingIndicator.hide();
              this.userService.showError('Problem Removing Item', 2000);
            })
        } else {
          event.sender.cancelCell();
          this.loadingIndicator.hide();
        }
      });
  }

  private closeEditor(grid, rowIndex = this._editedRowIndex) {
    grid.closeRow(rowIndex);
    this._editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

  isRowSelected = (e: RowArgs) => this.selectedKeys.includes(e.dataItem.glCode);

  gridCellClicked(event: any) {
    // console.log("gridCellClicked => ", event);
  }

  selectionKey(context: RowArgs): string {
    return context.dataItem.glCode;
  }

  rowCheckBoxChanged(checked: boolean, glcode: GLCode) {
    if (checked) {
      this.selectAllState = 'checked';
      this.selectedGLCodesMap.set(String(glcode.glCode), glcode);
    } else {
      this.selectedGLCodesMap.delete(String(glcode.glCode));
      this.selectAllState = 'unchecked';
    }
  }

  private validateForm() {
  this.isAddValid = Boolean(
    this._newSummaryTextValue !== null &&
    this._newSummaryTextValue !== undefined &&
    this._newCodeTextValue !== null &&
    this._newCodeTextValue !== undefined &&
    this._newDescriptionTextValue?.trim()
  );
}

  get newSummaryTextValue(): number {
    return this._newSummaryTextValue;
  }

  set newSummaryTextValue(value: number) {
    this._newSummaryTextValue = value;
    this.validateForm();
  }

  newSummaryTextBoxChange(newValue) {
    this.newSummaryTextValue = newValue;
  }

  get newCodeTextValue(): number {
    return this._newCodeTextValue;
  }

  set newCodeTextValue(value: number) {
    this._newCodeTextValue = value;
    this.validateForm();
  }

  newCodeTextBoxChange(newValue) {
    this.newCodeTextValue = newValue;
  }

  get newDescriptionTextValue(): string {
    return this._newDescriptionTextValue;
  }

  set newDescriptionTextValue(value: string) {
    this._newDescriptionTextValue = value;
    this.validateForm();
  }

  newDescriptionTextBoxChange(newValue) {
    this.newDescriptionTextValue = newValue;
  }




  //Excel export
  public exportAllData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.glCodes, {}).data,
    };
    return result;
  }

  excelExported($event: ExcelExportEvent) {
    const sheet = $event.workbook.sheets[0];
    sheet.freezePane.rowSplit = 0;
    sheet.name = 'Gl-codemaintenance';
  }

  exportToExcel(Glcode: GridComponent) {
    try {
      this.loadingIndicator.show();
      setTimeout(() => {
        Glcode.saveAsExcel();
        this.loadingIndicator.hide();
      }, 100);
    } catch (ex) {
      this.dialogService.showErrorNotification('There was a problem exporting this worksheet, please try again later');
      this.loadingIndicator.hide();
    }
  }

  //PDF export
  exportToPDF(Glcode: GridComponent) {
    try {
      this.loadingIndicator.show();
      setTimeout(() => {
        Glcode.saveAsPDF();
        this.loadingIndicator.hide();
      }, 100);
    } catch (ex) {
      this.dialogService.showErrorNotification('There was a problem exporting this worksheet, please try again later');
      this.loadingIndicator.hide();
    }
  }

}


